import React from 'react'
import styled from 'styled-components'

import Skeleton from 'components/lib/DesignSystem/Skeleton'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 162px;
  padding: 16px;
  border: 1px solid var(--card-border-color);
  background: var(--color-surface);
  border-radius: 20px;
  box-shadow: var(--shadow-1);
  overflow: hidden;

  @media (max-width: 1000px) {
    align-items: flex-start;
  }
`

const MainContent = styled.div`
  display: flex;
  flex: 1;
  gap: 16px;
  min-width: 0;
`

const SkeletonBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
`

const HeaderRow = styled.div`
  display: flex;
  gap: 12px;
`

const TriggerDetailsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`

const BottomDetailsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`

const BottomDetailGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

const Divider = styled.div`
  width: 1px;
  height: 12px;
  background-color: var(--card-border-color);
`

const SideContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  align-self: stretch;
  justify-content: space-between;
  min-width: 64px;

  @media (max-width: 1000px) {
    display: none;
  }
`

const SideTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`

const RatingGroup = styled.div`
  display: flex;
  gap: 8px;
`

const CardsLoadingPlaceholder = () => (
  <Container data-testid="Psima_Dashboard_CardsLoadingPlaceholder_div">
    <MainContent>
      <Skeleton variant="custom" width="20px" height="20px" borderRadius="4px" />
      <SkeletonBody>
        <HeaderRow>
          <Skeleton variant="custom" width="329px" height="24px" borderRadius="4px" />
        </HeaderRow>
        <Skeleton variant="custom" width="329px" height="24px" borderRadius="4px" />
        <Skeleton variant="custom" width="640px" height="40px" borderRadius="4px" />
        <TriggerDetailsRow>
          <Skeleton variant="custom" width="118px" height="20px" borderRadius="4px" />
          <Divider />
          <Skeleton variant="custom" width="171px" height="20px" borderRadius="4px" />
          <Divider />
          <Skeleton variant="custom" width="290px" height="20px" borderRadius="4px" />
        </TriggerDetailsRow>
        <BottomDetailsRow>
          <BottomDetailGroup>
            <Skeleton variant="custom" width="16px" height="16px" borderRadius="4px" />
            <Skeleton variant="custom" width="98px" height="20px" borderRadius="4px" />
          </BottomDetailGroup>
          <Divider />
          <BottomDetailGroup>
            <Skeleton variant="custom" width="29px" height="20px" borderRadius="4px" />
            <Skeleton variant="custom" width="141px" height="20px" borderRadius="4px" />
          </BottomDetailGroup>
          <Divider />
          <Skeleton variant="custom" width="114px" height="20px" borderRadius="4px" />
          <Skeleton variant="custom" width="76px" height="20px" borderRadius="4px" />
          <Skeleton variant="custom" width="131px" height="20px" borderRadius="4px" />
          <Skeleton variant="custom" width="67px" height="20px" borderRadius="4px" />
        </BottomDetailsRow>
      </SkeletonBody>
    </MainContent>
    <SideContent>
      <SideTextGroup>
        <Skeleton variant="custom" width="83px" height="20px" borderRadius="4px" />
        <Skeleton variant="custom" width="44px" height="16px" borderRadius="4px" />
      </SideTextGroup>
      <RatingGroup>
        <Skeleton variant="custom" width="28px" height="28px" borderRadius="4px" />
        <Skeleton variant="custom" width="28px" height="28px" borderRadius="4px" />
      </RatingGroup>
    </SideContent>
  </Container>
)

export default CardsLoadingPlaceholder
